const date_filters = [
  {value: "today", label: "Today"},
  {value: "yesterday", label: "Yesterday"},
  {value: "this_week", label: "This Week"},
  {value: "last_week", label: "Last Week"},
  {value: "this_month", label: "This Month"},
  {value: "last_month", label: "Last Month"},
  {value: "this_year", label: "This Year"},
  {value: "last_year", label: "Last Year"},
]

const filterByOptions = [
  {value: "branch", label: "Filter By Branch"},
  {value: "manager", label: "Filter By  Manager"},
]

export const initialState = {

  filterBy: "branch",
  filterByOptions: filterByOptions,
  branch_id: "",
  user_id: "",

  date_filters: date_filters,

  is_loading_recent_sales: false,
  recent_sales: [],

  is_loading_total_sales: true,
  total_sales_date: "this_month",
  total_sales: 0,

  is_loading_total_pullouts: true,
  total_pullouts_date: "this_month",
  total_pullouts: 0,

  total_date: "this_month",
  is_loading_total: false,

  is_loading_total_expenses: true,
  total_expenses_date: "this_month",
  total_expenses: 0,

  is_loading_total_payments: true,
  total_payments_date: "this_month",
  total_payments: 0,

  is_loading_counts: true,
  counts: {
    products: 0,
    suppliers: 0,
    customers: 0,
    users: 0,
  },

  is_loading_chart_expenses: true,
  chart_expenses: [],

  is_loading_chart_sales: true,
  chart_sales: [],
};
